export default __webpack_public_path__ + "static/media/wallet--light.60fbc32b.svg";